export default __webpack_public_path__ + "static/media/tickets.ea882478.png";